/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
// Node Modules
import React from 'react'

import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

const SEO = ({
  children,
  description,
  lang,
  noIndex,
  noUmaInTitle,
  ogImage,
  title,
  useUMAAcronym,
}) => {
  const { defaultSEOImage, site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
        defaultSEOImage: wpMediaItem(guid: {regex: "/UMA-logo.jpg/ig"}) {
          localFile {
            publicURL
          }
        }
      }
    `,
  )

  const composedDescription = description || site.siteMetadata.description
  const composedOGImage = ogImage || defaultSEOImage.localFile.publicURL
  let composedTitle = noUmaInTitle ? '%s' : `%s | ${site.siteMetadata.title}`

  if (useUMAAcronym) {
    composedTitle = '%s | UMA'
  }

  return (
    <Helmet
      defer={false}
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={composedTitle}
      meta={[
        {
          content: 'website',
          name: 'og:type',
        },
        {
          content: 'Ultimate Medical Academy',
          name: 'og:site_name',
        },
        {
          content: 'summary',
          name: 'twitter:card',
        },
        {
          content: '@UltimateMedical',
          name: 'twitter:site',
        },
        {
          content: '@UltimateMedical',
          name: 'twitter:creator',
        },
      ]}>

      {noIndex && <meta name="robots" content="noindex,nofollow,noarchive" />}

      <meta name="og:locale" content={lang} />

      <meta name="og:title" content={title} />
      <meta name="twitter:title" content={title} />

      <meta name="description" content={composedDescription} />
      <meta name="og:description" content={composedDescription} />
      <meta name="twitter:description" content={composedDescription} />

      <meta name="og:image" content={composedOGImage} />

      {children}
    </Helmet>
  )
}

SEO.defaultProps = {
  children: undefined,
  description: undefined,
  lang: 'en-US',
  noIndex: false,
  noUmaInTitle: false,
  ogImage: '',
  useUMAAcronym: false,
}

SEO.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  description: PropTypes.string,
  lang: PropTypes.string,
  noIndex: PropTypes.bool,
  noUmaInTitle: PropTypes.bool,
  ogImage: PropTypes.string,
  title: PropTypes.string.isRequired,
  useUMAAcronym: PropTypes.bool,
}

export default SEO
